import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import Swal from 'sweetalert2';
import { WaiterService } from '../../../_service/waiter.service';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-transfer',
  standalone: true,
  imports: [RouterModule,CommonModule],
  templateUrl: './transfer.component.html',
  styleUrl: './transfer.component.scss'
})
export class OrderTransferComponent {
  transferDetails: any = JSON.parse(localStorage.getItem('transfer_details') || '{}');
  constructor(private route: ActivatedRoute,
    private service: WaiterService,
    private router: Router,
    private toastr: ToastrService,
  ) { }
  ngOnInit(): void {
    this.transferDetails = JSON.parse(localStorage.getItem('transfer_details') || '{}');
    // localStorage.removeItem('transfer_details');
  }
  initiatePayment(payment_method: any) {
    const data = {
      order_id: this.route.snapshot.paramMap.get('id'),
      payment_method: payment_method
    }
    this.service.initiatePayment(data).subscribe({
      next: (res: any) => {
        if (res.payment_status == 'approved') {
          // this.toastr.success(`₦${res.amount} has been received`, 'Payment received', {
          //   timeOut: 3000
          // });
          Swal.fire({
            title: 'Payment Confirmed',
            text: `₦${res.amount} has been received`,
            icon: 'success',
            confirmButtonText: 'Done'
          })
          this.router.navigateByUrl(`/orders/${this.route.snapshot.paramMap.get('id')}`)
        }
      }, error: (err) => {
        Swal.fire('Failed', err.error.message, 'error')
      }, complete: () => { }
    })
  }
}
